module.exports = __webpack_public_path__ + "79f5537a79b0a81d7b0658d8ab440130.glb";